export const setBuyerMeetings = (data) => ({
    type: 'BUYER_SET_MEETINGS',
    data,
});
